import { toast } from 'react-toastify'

import API from "../../api";
import { queryClient } from "../../react-query"
import { useSupport } from '../../../store/global/useSupport';
import { formatResponses } from '../../formatResponses/support';
import qs from 'qs'

export class SupportModel {
  supportAction = useSupport.getState().actions

  // storeId,
  // include_closed,
  // subtasks,
  // page,
  // limit,
  // keyword,
  // archived,
  // order_by,
  // reverse,
  // status,
  // category

  async findTickets(storeId, options = {}) {
    try {
      const queryParams = qs.stringify({ storeId, ...options })
      const result = await queryClient.ensureQueryData({
        queryKey: ['support', 'tasks', storeId, JSON.stringify(options)],
        queryFn: async () => await API.get(`/clickup/tasks?${queryParams}`,),
      })

      const formattedTickets = formatResponses.tasks(result.data?.tasks || []);

      this.supportAction.setTickets(formattedTickets)
      return result.data
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível carregar os Chamados', { theme: 'colored' })
    }
  }
}
